export default "__VITE_ASSET__1077ba45__"